module.exports = __webpack_public_path__ + "static/media/LOST.8e648bb4.png";